<template>
  <div>
    <div class="d-flex justify-content-end">
      <div class="d-flex justify-content-between button-group">
        <img v-if="currentRoutePermissions.add_partner"
             src="@/assets/images/common-icons/icon_create.svg" @click="createPartner"
             title="Create partner">
        <img v-if="currentRoutePermissions.delete_partner"
             src="@/assets/images/common-icons/icon_delete.svg" @click="deletePartner"
             title="Delete partners">
        <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
             :title="$t('buttons.common.clear_filters')">
        <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
             :title="$t('buttons.common.search')">
      </div>
    </div>
    <div class="search-form">
      <div class="search-form__filters">
        <b-row>
          <b-col cols="4">
            <label>{{$t('labels.partner.role')}}</label>
            <multiselect v-model="searchData.roles" :max-height="200"
                         placeholder="Choose role" label="name" track-by="name"
                         :options="roles" :multiple="true"
                         :close-on-select="false"></multiselect>
          </b-col>
          <b-col cols="4">
            <label>{{$t('labels.partner.country')}}</label>
            <multiselect v-model="searchData.countries_codes" :max-height="200"
                         placeholder="Choose country" label="name" track-by="name"
                         :options="countries" :multiple="true"
                         :close-on-select="false"></multiselect>
          </b-col>
          <b-col cols="4">
            <label>{{$t('labels.partner.partner_name')}}</label>
            <input class="form-control" placeholder="Enter name" v-model="searchData.name"
                   @keyup.enter="search">
          </b-col>
        </b-row>
        <b-row>
          <b-col offset="8" cols="4">
            <label>{{$t('labels.partner.official_name')}}</label>
            <input class="form-control" placeholder="Enter official name" @keyup.enter="search"
                   v-model="searchData.official_name">
          </b-col>
        </b-row>
      </div>
      <div>
        <b-row>
          <b-col cols="4">
            <input class="form-control"
                   placeholder="Filter..."
                   @input="setQuickFilter">
          </b-col>
          <b-col cols="4" offset="4" class="vertical-center-container justify-content-end">
            <label for="pagination-toggle" class="margin-right-5">Pagination</label>
            <input id="pagination-toggle" type="checkbox"
                   title="this checkbox needed for toggle pagination bar" v-model="paginationState"
                   @change="togglePagination">
            <save-columns-btn :grid="partnersGridOptions" :grid-name="gridName"
                              class="margin-left-5"></save-columns-btn>
          </b-col>
        </b-row>
      </div>
    </div>
    <div>
      <b-row>
        <b-col>
          <ag-grid-vue class="ag-theme-balham grid" :gridOptions="partnersGridOptions"
                       @rowDoubleClicked="goToPartner" :style="gridHeight"
                       :columnDefs="partnersColumns" :rowData="partners" :postProcessPopup="postProcessPopup">
          </ag-grid-vue>
        </b-col>
      </b-row>
    </div>
    <div>
      <b-row class="pagination__wrapper" v-if="paginationState">
        <b-col cols="5">
          <div class="pagination-info">{{countOfViewPartners}} {{$t('common_content.of')}} {{partnersCount}}
          </div>
        </b-col>
        <b-col cols="7">
          <b-pagination size="md" :total-rows="partnersCount" :per-page="searchObject.limit"
                        v-model="currentPaginateIndex"
                        @input="changePaginateState"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import { mapGetters, mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import {
    cleanFilters,
    saveFilters,
    setFilters,
    checkSavedFilterData,
    getArrayByProperty,
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import SaveColumnsBtn from '@/components/common/SaveColumnsBtn';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { gridMixins } from '@/mixins';

  export default {
    mixins: [gridMixins],
    components: {
      Multiselect,
      'ag-grid-vue': AgGridVue,
      SaveColumnsBtn
    },
    data() {
      return {
        searchObject: {
          limit: 100,
          offset: 0
        },
        searchData: {
          roles: [],
          countries_codes: [],
          name: '',
          official_name: ''
        },
        paginationState: true,
        currentPaginateIndex: 1
      }
    },
    methods: {
      createPartner() {
        this.$router.push({path: `/partners/new`});
      },
      deletePartner() {
        const id = getArrayByProperty(this.partnersGridOptions.api.getSelectedRows(), 'id').toString();
        const body = {
          ids: getArrayByProperty(this.partnersGridOptions.api.getSelectedRows(), 'id')
        };
        if (id.length) {
          this.$http.delete(`partner/partners/`, {body}).then(handlerResponse).then((response) => {
            this.currentPaginateIndex = 1;
            this.$store.dispatch('generalPartners/loadPartners', this.searchObject);
            this.$notify(setNotifyData('', response, 'success'));
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          })
        } else {
          this.$notify(setNotifyData('Select at least one partner', '', 'error'));
        }
      },
      search() {
        this.currentPaginateIndex = 1;
        this.searchObject = {
          ...this.searchObject,
          roles: getArrayByProperty(this.searchData.roles, 'key').toString(),
          countries_codes: getArrayByProperty(this.searchData.countries_codes, 'short_name').toString(),
          name: this.searchData.name,
          official_name: this.searchData.official_name
        };
        this.$store.dispatch('generalPartners/loadPartners', this.searchObject);
        saveFilters('generalPartners', this.searchData);
      },
      changePaginateState() {
        const searchObject = {...this.searchObject, offset: (this.currentPaginateIndex - 1) * this.searchObject.limit};
        this.$store.dispatch('generalPartners/loadPartners', searchObject);
      },
      cleanFilters() {
        cleanFilters(this.searchData);
      },
      setQuickFilter(e) {
        this.partnersGridOptions.api.setQuickFilter(e.target.value);
      },
      goToPartner(params) {
        if (params.data.id) {
          this.$router.push({path: `/partners/${params.data.id}`});
        }
      },
      togglePagination() {
        this.setUpPagination()
        this.search();
      },
      setUpPagination() {
        if (!this.paginationState) {
          delete this.searchObject.limit;
          delete this.searchObject.offset;
        } else {
          this.searchObject.limit = 100;
          this.searchObject.offset = 0;
        }
      }
    },
    beforeMount() {
      this.$store.cache.dispatch('woodware/getCountries');
      this.$store.cache.dispatch('generalPartners/loadRoles');
      if (checkSavedFilterData('generalPartners')) {
        this.searchData = setFilters('generalPartners');
      }
      this.setUpPagination();
      this.search();
    },
    computed: {
      ...mapState('generalPartners', ['gridName']),
      ...mapState('generic', ['currentRoutePermissions']),
      ...mapGetters('generalPartners', {
        partnersGridOptions: 'partnersGridOptions',
        partners: 'partners',
        roles: 'roles',
        partnersColumns: 'partnersColumns',
        partnersCount: 'partnersCount'
      }),
      ...mapGetters('woodware', {
        countries: 'countries'
      }),
      countOfViewPartners() {
        return this.partners.length;
      },
      gridHeight() {
        return {height: 'calc(100vh - 335px)'}
      }
    }
  }

</script>

<style scoped>

  .grid {
    height: 640px;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/modules/general/partners/PartnersList.vue